// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar_scrollbar__fMU5B"};